import DatabaseModel from './DatabaseModel.js';

var PlazoDias = Object.create(DatabaseModel);

PlazoDias.model = 'plazodias';
PlazoDias.modelFront = 'plazodias';

export default PlazoDias;